module.exports = __webpack_public_path__ + "static/media/Icons-8.d3eeb591.svg";